import { CommandMeetingToNote } from "../engagements/commands/cmdMeetingToNote";
import { CommandCreateNote } from "./commands/cmdCreateNotebook";
import { CommandDeleteNote } from "./commands/cmdDeleteNote";
import { CommandFetchNotebook } from "./commands/cmdFetchNotebook";
import { CommandFetchNotebooks } from "./commands/cmdFetchNotebooks";
import { CommandFetchNotes } from "./commands/cmdFetchNotes";
import { CommandNotebook } from "./commands/cmdNotebook";
import { CommandNoteDetails } from "./commands/cmdNoteDetails";
import { CommandFetchTemplates } from "./commands/cmdFetchTemplates.ts";
import {CommandUpdateNote} from "./commands/cmdUpdateNote.ts";
import {Note} from "@models/note.model.ts";
import {CommandMoveNote} from "@services/notebook/commands/cmdMoveNote.ts";

export class NotebookService {


    async getNotebooks(organizationId: number) {
        const cmd = new CommandFetchNotebooks();
        const results = await cmd.run(organizationId);
        return results;
    }

    async createNotebook(organizationId: number) {
        const cmd = new CommandNotebook();
        const results = await cmd.run(organizationId);
        return results;
    }

    async getNotebookDetails(notebookId: number) {
        const cmd = new CommandFetchNotebook();
        const results = await cmd.run(notebookId);
        return results;
    }

    async getNotes(notebookId: number, parentId: number | null) {
        const cmd = new CommandFetchNotes();
        const results = await cmd.run(notebookId, parentId);
        return results;
    }


    async createNote(notebookId:number, parentId: number | null = null, title: string = '-- new note --', content: string = '', type: string = 'note' ) {
        const cmd = new CommandCreateNote();
        const results = await cmd.run(notebookId, parentId, title, content, type);
        return results;
    }

    async updateNote(notebookId:number, note: Note) {

        const cmd = new CommandUpdateNote();
        const results = await cmd.run(notebookId, note);
        return results;
    }

    async moveNote(notebookId:number, note: Note) {

        const cmd = new CommandMoveNote();
        const results = await cmd.run(notebookId, note);
        return results;
    }

    async getNoteDetails(notebookId: number, noteId: number) {
        const cmd = new CommandNoteDetails();
        const results = await cmd.run(notebookId, noteId);
        return results;
    }

    async deleteNote(notebookId:number,noteId:number) {
        const cmd = new CommandDeleteNote();
        const results = await cmd.run(notebookId, noteId);
        return results;
    }

    async getTemplates(notebookId: number) {
        const cmd = new CommandFetchTemplates();
        const results = await cmd.run(notebookId);
        return results;
    }

    async convertMeetingToNote(meetingId: string, notebookId: string) {
        const cmd = new CommandMeetingToNote();
        const results = await cmd.run(meetingId, notebookId);
        return results;
    }
   
    
}

